import { Button, CircularProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { postFetch } from "../../../fetch/fetch";
import styles from "../mobilesignup2style.module.css"
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

const SignupFinish: React.FC<any> = (props) => {

    const [loading, setLoading] = useState(false);

    const submit = async () => {

        console.log("자동 로그인 시도", props.phoneNumber, props.password);

        if (!props.phoneNumber || !props.password) {
            alert("자동 로그인에 필요한 정보가 부족합니다. 다시 시도해주세요.");
            return;
        }

        try {

            console.log("자동 로그인 시작");

            setLoading(true);

            const result: any = await postFetch("/login/loginbyphonenumber", {
                phoneNumber: props.phoneNumber,
                password: props.password
            });

            console.log(result);

            setLoading(false);

            if (result.message === "notNow") {
                alert("재원생 승인 후 가능합니다.");
                return;
            }

            if (result.message === "success") {

                const isMultiple = result.isMultiple;

                if (!isMultiple) {

                    if (window.electron) {
                        const returnValue = window.electron.sendMessageApi.setToken(result.token);
                    }

                    if (Capacitor.isNativePlatform()) {

                        const token = result.token;

                        await Preferences.set({
                            key: "token",
                            value: token
                        })
                    }

                    props.history.push("/mobiledashboard");

                } else {

                    if(!props.phoneNumber || !props.password){
                        alert("자동 로그인에 필요한 정보가 부족합니다. 다시 시도해주세요.");
                        return;
                    }

                    const accounts = result.accounts;

                    props.history.push({
                        pathname: "/multipleuserlogin",
                        state: {
                            phoneNumber: props.phoneNumber,
                            users: accounts,
                            password: props.password,
                            pc : true
                        }
                    })

                }



            } else {
                alert("자동 로그인에 실패했습니다. 다시 시도해주세요.");
            }

        } catch (e) {
            console.error(e);
        }


    }



    //로그인 정보 제출----------------------------------------------------------------------------------
    // const submit = (e: any) => {

    //     setShowLoading(true);

    //     e.preventDefault();

    //     setEmailError(false);
    //     setPasswordError(false);

    //     fetch("https://peetsunbae.com/login/submit", {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify({
    //             email: email.split(" ").join(""),
    //             password: password,
    //         })
    //     }).then((response) => {
    //         response.json()
    //             .then(async (result) => {

    //                 setShowLoading(false);
    //                 //로그인 성공 시--------------------------------------------------------------------------
    //                 if (result.message === "success") {
    //                     if (window.electron) {

    //                         const returnValue = window.electron.sendMessageApi.setToken(result.token);
    //                         // const returnValue2 = ipcRenderer.sendSync("setToken", result.token);

    //                         // 
    //                     }
    //                     if (Capacitor.isNativePlatform()) {


    //                         const token = result.token;

    //                         await Preferences.set({
    //                             key: "token",
    //                             value: token
    //                         })

    //                     }
    //                     props.history.push("/mobiledashboard");
    //                 }
    //                 //-----------------------------------------------------------------------------------
    //                 if (result.message === "fail") {
    //                     setPasswordError(true);
    //                 }
    //                 if (result.message === "emailfail") {
    //                     setEmailError(true);
    //                 }
    //                 if (result.message === "notNow"){
    //                     alert("재원생 승인 후 가능합니다.");
    //                 }


    //             })
    //     }).catch((error) => {

    //     })

    // }
    //--------------------------------------------------------------------------------------------------

    return (
        <div style={{
            height: props.totalBodyHeight ? `${props.totalBodyHeight}px` : "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent:  props.pc ? "center" : "space-between",
            // paddingBottom: "39px",
            paddingBottom : props.pc ? "" : "max(var(--safe-area-inset-bottom), 39px)",
        }}
            className={styles.mainContainer}
        >
            <div>
            </div>

            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom : props.pc ? "30px" : "0px"
            }}>
                <div>
                    <img src="img/party-face.webp" alt="partyface" style={{
                        width: "160px"
                    }} />
                </div>
                <div style={{
                    marginTop: "80px",
                    color: "#4e5867",
                    fontSize: "18px",
                    fontFamily: "Apple_R",
                    marginBottom: "34px",
                    letterSpacing: "-2%",
                }}>
                    {
                        props.type && props.type === "findpassword" ? "비밀번호 재설정 완료!" : "회원가입 완료!"
                    }
                </div>
                {
                    props.type && props.type === "findpassword" ? null :
                        <div style={{
                            fontFamily: "Apple_B",
                            fontSize: "32px",
                            lineHeight: "140%",
                            letterSpacing: "-2%",
                            textAlign: "center",
                            color: "#202632",
                        }}>
                            {props.name}님,<br />환영합니다!
                        </div>

                }

            </div>

            <div style={{
                width: "100%"
            }}>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#3d50b0",
                        height: "52px",
                        borderRadius: "13px",
                        fontWeight: 500,
                        fontFamily: "Apple_R",
                        boxShadow: "none !important",
                        "&.Mui-disabled": {
                            backgroundColor: "#C1d6f3",
                            color: "white",
                        },
                        "&:hover": {
                            backgroundColor: "#3d50b0",
                            boxShadow: "none",
                        },
                        "&:active": {
                            backgroundColor: "#3d50b0",
                        },
                        "&.Mui-focusVisible": {
                            backgroundColor: "#3d50b0",
                        },
                    }}
                    fullWidth
                    disabled={loading}
                    onClick={submit}
                >
                    {!loading ? "시작하기" : <CircularProgress size={24} style={{ color: "white" }} />}
                </Button>
            </div>


        </div>
    )

}

export default SignupFinish;